// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainLayout {
  display: flex;
  align-content: stretch;
  flex-direction: column !important;
  padding-bottom: 0px;
  margin-bottom: 0px;
  min-height: 100vh !important;
}
.announcement {
  display: flex;
  justify-content: center;
  padding: 10px;
  background: #fefacc;
  font-size: 16px;
  font-weight: 500;
}

h1 {
  font-weight: normal;
}

.chat-left #hubspot-messages-iframe-container {
  left: 0 !important;
  right: unset !important;
}

.disabled {
  pointer-events: none;
  color: rgba(0, 0, 0, 0.54);
  background-color: rgb(255, 255, 255);
  opacity: 0.6;
}

.chat-left div:has(iframe[title='Messaging window']) {
  left: 0 !important;
  right: unset !important;
}

.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid #eee;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

@media (max-width: 1024px) {
  .mobileHidden {
    display: none !important;
  }
  .mobileVisible {
    display: block;
  }
}

@media (min-width: 1024px) {
  .mobileVisible {
    display: none;
  }

  .Profile-Box {
    padding: 50px 100px 10px 100px !important;
    margin-bottom: 0px !important;
  }
}

.center-loader {
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/v3/assets/css/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,8DAA8D;AAChE;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;EACA;IACE,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,yCAAyC;IACzC,6BAA6B;EAC/B;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".mainLayout {\n  display: flex;\n  align-content: stretch;\n  flex-direction: column !important;\n  padding-bottom: 0px;\n  margin-bottom: 0px;\n  min-height: 100vh !important;\n}\n.announcement {\n  display: flex;\n  justify-content: center;\n  padding: 10px;\n  background: #fefacc;\n  font-size: 16px;\n  font-weight: 500;\n}\n\nh1 {\n  font-weight: normal;\n}\n\n.chat-left #hubspot-messages-iframe-container {\n  left: 0 !important;\n  right: unset !important;\n}\n\n.disabled {\n  pointer-events: none;\n  color: rgba(0, 0, 0, 0.54);\n  background-color: rgb(255, 255, 255);\n  opacity: 0.6;\n}\n\n.chat-left div:has(iframe[title='Messaging window']) {\n  left: 0 !important;\n  right: unset !important;\n}\n\n.lds-ripple {\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n.lds-ripple div {\n  position: absolute;\n  border: 4px solid #eee;\n  opacity: 1;\n  border-radius: 50%;\n  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;\n}\n.lds-ripple div:nth-child(2) {\n  animation-delay: -0.5s;\n}\n@keyframes lds-ripple {\n  0% {\n    top: 36px;\n    left: 36px;\n    width: 0;\n    height: 0;\n    opacity: 1;\n  }\n  100% {\n    top: 0px;\n    left: 0px;\n    width: 72px;\n    height: 72px;\n    opacity: 0;\n  }\n}\n\n@media (max-width: 1024px) {\n  .mobileHidden {\n    display: none !important;\n  }\n  .mobileVisible {\n    display: block;\n  }\n}\n\n@media (min-width: 1024px) {\n  .mobileVisible {\n    display: none;\n  }\n\n  .Profile-Box {\n    padding: 50px 100px 10px 100px !important;\n    margin-bottom: 0px !important;\n  }\n}\n\n.center-loader {\n  display: flex;\n  flex-grow: 1;\n  align-items: center;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
